// Keep this aligned with hrmis.app.jwtExpirationMs in the backend.
export const ACCESS_TOKEN_COOKIE_EXPIRY_DAYS = 6 / 24;
export const REFRESH_TOKEN_COOKIE_EXPIRY_DAYS = 7;
